export * from './handlers';

export const testCreds = {
  identifier: 'cashappclone1@gmail.com',
  password: 'asdf',
};
